import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

export default function QnaSection ({qnaData, eleRef}){
    // console.log("@@@@@@@@@@@ " , qnaData);
    // var eleRef = qnaData.eleRef;
    // var qnaData = qnaData.qnaData;
    return(
        <section className="qna-section">
            <div className="section-title">Q&A</div>
            <div className="queBlock">
            {qnaData.data.map((question, i2) => 
            <div key={i2} className="question-block">
                <div className="expecting-mom R13_9e">
                    <span className="expecting-due left">{question.user_description}</span>
                    <span className="last-online-time right">{question.posted_time}</span>
                </div>
                <div className="parenting-ques">
                    <a href={service.getRedirectUrl(`/qna/q/${service.genquestionurl(question.question_title) + '-' + (question.question_id)}`)} className="que-container">
                        <span className="M17_42 qmore" id="">
                            <span className="M17_9e q-symbol">Q. </span>{question.question_title}
                        </span>
                    </a>
                    <div className="readmore_popup que-readmore">
                        <div className="readmorelink R14_link">Read More</div>
                    </div>
                </div>
                <div className="social-actions">
                    <div className="answer R13_9e mrgright left" id="" onClick={() => actions.gotoQnaAns(service.genquestionurl(question.question_title) + '-' + (question.question_id))}>
                        <div data-icon-font="H" className="icon pencil dev_landingPencil"  ></div>Answer
                    </div>
                    {/* <a href={service.getRedirectUrl(`/qna/q/${service.genquestionurl(question.question_title) + '-' + (question.question_id)}`)}> */}
                        <div className="answer answer-cnt R13_9e left">
                            <div data-icon-font="" className="icon cmt-icon"></div>
                            <span>{question.answer_count}</span>
                        </div>
                    {/* </a> */}
                    <div className="follow-abuse right"> 
                    {/* onClick={() => actions.gotoQnaFllow(service.genquestionurl(question.question_title) + '-' + (question.question_id))} */}
                        <span className={question.que_follow && question.que_follow != 'false' ? "unfollowqa R13_9e" : "followqa R13_9e"} onClick={actions.saveQueActions.bind(this, question.que_follow && question.que_follow != 'false' ? 0 : 1, question.question_id, question.creater_id, question.question_title, "follow", eleRef)} >
                        + {question.que_follow && question.que_follow != 'false' ?
                        `Following | ${question.follow_count}` :
                        `Follow | ${question.follow_count}`
                        }
                        </span>
                    </div>
                </div>
            </div>
            )}
            </div>
            {qnaData.search_cnt > qnaData.data.length &&
            <div className="moreResults dev_v_all" title="Q&A" onClick={()=>eleRef.getMoreSearchData(qnaData.type)}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
